const themebkl = {
    primary: '#01662c',
    secondary: '#f75f14',
    btnprimary: '#01662c',
};
export default themebkl